import { FormikProps, useFormik } from "formik";
import { object, string, boolean, mixed } from "yup";
import CaptureFormPresenter from "./CaptureFormPresenter";
import { useHandleChange } from "@arelia-hooks/formikHooks";
import { Box, Link, useMediaQuery } from "@mui/material";
import theme from "src/theme";
import { useParams } from "react-router-dom";
import { usePostCaptureForm, usePublicAccoutDataAPI } from "./hooks";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { useState } from "react";

export type EditForm = {
  email: string;
  fullName: string;
  phone: string;
  country: string;
  city: string;
  smsConsent: boolean;
  captchaToken: string | null;
};

export default function CaptureFormContainer() {
  const [submitted, setSubmitted] = useState(false);
  const { publicId } = useParams();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const { data: account, isLoading } = usePublicAccoutDataAPI(publicId as string);
  const { mutate: postCaptureForm } = usePostCaptureForm(publicId as string, setSubmitted);

  const submitUpdates = (form: EditForm) => postCaptureForm(form);

  const validationSchema = object({
    fullName: string().required("Name is required"),
    phone: string().required("Phone number is required"),
    smsConsent: boolean().oneOf([true], "You must agree to receive SMS messages"),
    captchaToken: mixed().required("Please complete the CAPTCHA verification")
  });

  const formik: FormikProps<EditForm> = useFormik<EditForm>({
    initialValues: {
      country: '',
      email: '',
      fullName: '',
      city: '',
      phone: '',
      smsConsent: false,
      captchaToken: null
    },
    validationSchema,
    onSubmit: submitUpdates,
    enableReinitialize: true,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: true,
  });

  const handeChange = useHandleChange<EditForm>(formik);

  return <Box display="flex" width="100vw" height="100vh" flexDirection={'column'}>
    <SpinnerWrapper loading={isLoading}>
      {/* <UnauthorizedMenu
        account={account}
      /> */}
      <CaptureFormPresenter
        formik={formik}
        handeChange={handeChange}
        account={account}
        submitted={submitted}
      />
    </SpinnerWrapper>
    <Box display="flex" justifyContent="center" marginBottom="20px">
      <Link sx={{ marginX: "10px" }} href="https://areliatech.com/privacy-policy">Privacy Policy</Link> |
      <Link sx={{ marginX: "10px" }} href="https://areliatech.com/terms-of-service">Terms of Service</Link>
    </Box>
  </Box>;
}
